import React from 'react';

const WhitepaperCommand = () => {
    return (
        <div className="overview-container">
            {/* ASCII Art Title */}
            <pre className="ascii-art">{`
██╗    ██╗██╗  ██╗██╗████████╗███████╗██████╗  █████╗ ██████╗ ███████╗██████╗ 
██║    ██║██║  ██║██║╚══██╔══╝██╔════╝██╔══██╗██╔══██╗██╔══██╗██╔════╝██╔══██╗
██║ █╗ ██║███████║██║   ██║   █████╗  ██████╔╝███████║██████╔╝█████╗  ██████╔╝
██║███╗██║██╔══██║██║   ██║   ██╔══╝  ██╔═══╝ ██╔══██║██╔═══╝ ██╔══╝  ██╔══██╗
╚███╔███╔╝██║  ██║██║   ██║   ███████╗██║     ██║  ██║██║     ███████╗██║  ██║
 ╚══╝╚══╝ ╚═╝  ╚═╝╚═╝   ╚═╝   ╚══════╝╚═╝     ╚═╝  ╚═╝╚═╝     ╚══════╝╚═╝  ╚═╝`}</pre>

            {/* Main Content Box */}
            <div className="content-box">
                <div className="box-header">
                    📄📄 AI TRADER: WHITEPAPER 📄📄
                </div>

                <div className="box-content">
                    <section className="feature-section">
                        <h3>📊 Executive Summary</h3>
                        <p>
                            AI Trader represents a paradigm shift in the democratization of artificial
                            intelligence. By leveraging blockchain technology and our proprietary AIDER
                            token, we're creating a decentralized network that allows anyone to
                            contribute to and benefit from cutting-edge AI development. This whitepaper
                            outlines our revolutionary approach to open-source AI and the unprecedented
                            opportunities it presents for early adopters.
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>📈 Market Analysis</h3>
                        <p>
                            The AI market is projected to reach $190.61 billion by 2025, with a CAGR of
                            36.62%. However, current AI development is largely centralized and
                            inaccessible to the average person. AI Trader aims to disrupt this model,
                            tapping into the vast potential of distributed computing and creating new
                            value streams for participants.
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>💻 Technology</h3>
                        <p>
                            Our platform utilizes a novel consensus algorithm we call "Proof of
                            Computation" (PoC). Users contribute GPU power to train AI models, receiving
                            AIDER tokens as rewards. These models are then made available to the
                            community, fostering innovation and accessibility.
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>💎 Tokenomics</h3>
                        <p>
                            AIDER tokens serve as the fuel of our ecosystem. With a fixed supply of 1
                            billion tokens, AIDER's value is designed to appreciate as demand for AI
                            services grows. Our token distribution ensures a fair launch, with:
                        </p>
                        <ul>
                            <li>40% - Community rewards</li>
                            <li>20% - Team & Advisors</li>
                            <li>15% - Development</li>
                            <li>15% - Marketing and Partnerships</li>
                            <li>10% - Initial Exchange Offering</li>
                        </ul>
                    </section>

                    <section className="feature-section">
                        <h3>🗺️ Roadmap</h3>
                        <p>
                            Our strategic development timeline includes:
                        </p>
                        <ul>
                            <li>Q4 2024: Mainnet launch</li>
                            <li>Q1 2025: Partnerships with major tech companies</li>
                            <li>Q2 2025: Integration with popular AI frameworks</li>
                            <li>Q3 2025: Launch of AI Trader marketplace</li>
                            <li>Q4 2025: Projected 100x growth in network capacity</li>
                        </ul>
                    </section>

                    <section className="feature-section">
                        <h3>👥 Team</h3>
                        <p>
                            Our team consists of AI experts and blockchain veterans from institutions
                            like MIT, Stanford, and leading tech companies (names withheld due to
                            current contractual obligations).
                        </p>
                    </section>

                    <div className="disclaimer">
                        This whitepaper is for informational purposes only. Future projections and
                        statements are subject to change based on market conditions and technological
                        advancements.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhitepaperCommand;
